import React, { useEffect, useState, useContext } from "react";
import "./Home.css";
import HomeImage from "../../assets/images/home_image.png";
import Spinner from "../Spinner/Spinner";
import { LanguageContext } from "../../context/LanguageContext";

const Home = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    if (language === "german") {
      fetch("https://swissmailsecurity.ch/wp-json/wp/v2/posts/7")
        .then((res) => res.json())
        .then((res) => {
          setData(res.content.rendered);
          setIsLoading(false);
        });
    } else if (language === "french") {
      fetch("https://swissmailsecurity.ch/wp-json/wp/v2/posts/116")
        .then((res) => res.json())
        .then((res) => {
          setData(res.content.rendered);
          setIsLoading(false);
        });
    }
  }, [language]);

  return (
    <div className="home_container">
      <div className="home_inner_container">
        <div className="home_image_container">
          <img src={HomeImage} alt="home_image" className="home_image" />
        </div>
        <div className="home_content">
          <div className="home_title_container">
            <span
              className={
                language === "german"
                  ? "home_title_span_ger"
                  : "home_title_span_fra"
              }
            >
              {language === "german" ? "SWISS MAIL" : "COURRIER SUISSE"}
            </span>
            <h3
              className={
                language === "german" ? "home_title" : "home_title_fra"
              }
            >
              {language === "german" ? "SECURITY" : "SÉCURITÉ"}
            </h3>
          </div>
          {isLoading ? (
            <div className="home_content_loading">
              <Spinner />
            </div>
          ) : (
            <div
              className="home_text"
              dangerouslySetInnerHTML={{ __html: data }}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
